import React, { useState } from "react";
import { MessageSquarePlus } from "lucide-react";
import { FEEDBACK_MAX_CHARS } from "../../utils/constants/AdIntelligence";

/** A reviewer's optional note on one field; required, and always open, when the field's reason is "Other". */
const FieldNote = ({ value, required = false, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const shown = isOpen || required || !!value;

  if (!shown) {
    return (
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="mt-1 inline-flex items-center gap-1 px-1 text-xs text-gray-500 hover:text-[#3c3489]"
      >
        <MessageSquarePlus className="h-3.5 w-3.5" />
        Add a note
      </button>
    );
  }

  return (
    <textarea
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      rows={2}
      maxLength={FEEDBACK_MAX_CHARS}
      autoFocus={isOpen && !value}
      placeholder={
        required
          ? "Required for “Other”: what was wrong?"
          : "Your note on this field (optional)"
      }
      className={`mt-1.5 w-full rounded-md border bg-white px-2.5 py-1.5 text-xs shadow-sm focus:outline-none focus:ring-1 focus:ring-ring ${
        required && !(value || "").trim() ? "border-amber-300" : "border-input"
      }`}
    />
  );
};

export default FieldNote;
